/**
 * Parse error response from API and return a user-friendly message
 * @param {Error} error - The error object from axios
 * @param {string} defaultMessage - Default message if no specific error is found
 * @returns {string} - User-friendly error message
 */
export const parseErrorMessage = (error, defaultMessage = 'Ha ocurrido un error') => {
  if (!error.response?.data?.detail) {
    return defaultMessage;
  }

  const detail = error.response.data.detail;

  // Handle Pydantic validation errors (array of objects)
  if (Array.isArray(detail)) {
    return detail.map(err => {
      const field = err.loc?.[err.loc.length - 1] || 'campo';
      const message = err.msg || 'error de validación';
      return `${field}: ${message}`;
    }).join(', ');
  }

  // Handle string errors
  if (typeof detail === 'string') {
    return detail;
  }

  // Handle object errors
  if (typeof detail === 'object') {
    // Try to extract a meaningful message
    if (detail.message) return detail.message;
    if (detail.error) return detail.error;
    return JSON.stringify(detail);
  }

  return defaultMessage;
};

/**
 * Show error toast with proper message parsing
 * @param {Error} error - The error object
 * @param {Function} toastFn - The toast function (from sonner)
 * @param {string} defaultMessage - Default error message
 */
export const showErrorToast = (error, toastFn, defaultMessage) => {
  const message = parseErrorMessage(error, defaultMessage);
  toastFn(message);
};
